let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4h9Ss")).then(() => parcelRequire('9D9o8'));